/**
 * Download a file via HTTP post with parameters.
 *
 * @param {*} postData Post data for the url.
 * @param {*} url UrL to post to.
 */
function download(postData, url, token) {
    const downId = Date.now();
    const inputs = [];
    if (token) inputs.push(`<input type="hidden" name="_TOKEN" value="${token}" />`);
    const keys = Object.keys(postData);
    let value;
    for (let i = 0; i < keys.length; i++) {
        value = postData[keys[i]];
        if (typeof value === 'object') value = JSON.stringify(value);
        inputs.push(`<input type="hidden" name="${keys[i]}" value="${value}" />`);
    }
    // Create a new window to post back to get the file.
    const div = document.createElementNS('http://www.w3.org/1999/xhtml', 'div');
    div.setAttribute('id', `DOWN_${downId}`);
    div.setAttribute('style', 'position:fixed;opacity:0;z-index:-10');
    div.innerHTML = `<form id="FORM_${downId}" method="post" action="${url}">${inputs.join('')}</form>`;
    document.body.appendChild(div);

    const form = document.getElementById(`FORM_${downId}`);
    form.submit();
    document.body.removeChild(div);
}

export default {
    download
};



// WEBPACK FOOTER //
// ./src/util/FileDownload.js